import React from "react";
import { getServiceRequestListClientEmailOffer } from "../../utils/adminListClientEmailOffer";

/** @param {string} signal */
export function offerModifierClass(signal) {
  const s = String(signal || "");
  if (s === "accept_offer") return "admin-dash__email-offer-pill--accept";
  if (s === "reject_offer") return "admin-dash__email-offer-pill--reject";
  if (s === "negotiate") return "admin-dash__email-offer-pill--negotiate";
  return "admin-dash__email-offer-pill--unclear";
}

/**
 * Compact badge for **service requests table**: latest client-email offer stance (negotiate / accept / …).
 * Data from list `emailMessages` or denormalized API fields — see `getServiceRequestListClientEmailOffer`.
 */
export function ServiceRequestClientEmailBadge({ row }) {
  const info = getServiceRequestListClientEmailOffer(row);

  if (info.kind === "none") {
    return <span className="admin-dash__list-client-email-dash">—</span>;
  }

  if (info.kind === "pending") {
    return (
      <span
        className="admin-dash__list-client-email-pill admin-dash__list-client-email-pill--pending"
        title={info.hint || "Analysing latest client message"}
      >
        Analysing…
      </span>
    );
  }

  if (info.kind === "failed") {
    return (
      <span
        className="admin-dash__list-client-email-pill admin-dash__list-client-email-pill--failed"
        title={info.hint || "Analysis failed"}
      >
        Err
      </span>
    );
  }

  const title =
    [info.detail, info.label].filter(Boolean).join(" — ") || info.label;
  const mod = offerModifierClass(info.signal);

  return (
    <span
      className={`admin-dash__email-offer-pill admin-dash__email-offer-pill--table ${mod}`}
      title={title}
    >
      {info.label}
    </span>
  );
}
